import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 0h24v24H0z",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", { d: "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" })]
});
export default SvgDownload;
